import { Link } from "react-router-dom";
import { ArrowRight, FileText, BarChart3 } from "lucide-react";

const CARDS = [
  {
    to: "/invoice-capture",
    title: "Invoice Capture & Auto-fill",
    desc: "Upload a GST invoice, let Gemini extract every field, review with live validation, and book to ERP.",
    image:
      "https://images.pexels.com/photos/10662882/pexels-photo-10662882.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: FileText,
    tag: "Live AI",
  },
  {
    to: "/ask-the-data",
    title: "Ask the Data",
    desc: "Pick a department, ask a plain-English question, and get instant KPIs, a chart, and the SQL behind it.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxkYXRhJTIwYW5hbHl0aWNzJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc4NDY4MjI3MHww&ixlib=rb-4.1.0&q=85",
    icon: BarChart3,
    tag: "Prototype",
  },
];

export default function Overview() {
  return (
    <main className="max-w-5xl mx-auto py-16 px-6" data-testid="overview-page">
      <div className="mb-12">
        <p className="font-mono text-xs uppercase tracking-[0.15em] text-[#0E6E52] mb-3">
          KRCL · Finance &amp; Insights Console
        </p>
        <h1 className="text-4xl lg:text-5xl font-display font-medium tracking-tight text-[#141E1A]">
          Invoice &amp; Insights POC
        </h1>
        <p className="mt-4 text-base text-[#5A6B63] max-w-2xl leading-relaxed">
          A proof-of-concept for Konkan Railway Corporation. Invoice Capture runs live on Gemini;
          Ask the Data is a clickable prototype of what comes next.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {CARDS.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            data-testid={`overview-card-${c.to.replace("/", "")}`}
            className="group bg-white border border-[#DCE3DF] rounded-[10px] shadow-[0_4px_20px_rgba(20,30,26,0.06)] overflow-hidden transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(20,30,26,0.12)]"
          >
            <div className="h-40 relative overflow-hidden">
              <img src={c.image} alt={c.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#141E1A]/70 to-transparent" />
              <span className="absolute top-3 right-3 text-[10px] font-mono uppercase tracking-[0.1em] bg-white/90 text-[#0E6E52] rounded-full px-2 py-1">
                {c.tag}
              </span>
            </div>
            <div className="p-6">
              <div className="flex items-center gap-2 mb-2">
                <c.icon className="w-5 h-5 text-[#0E6E52]" />
                <h3 className="text-xl font-display font-medium text-[#141E1A]">{c.title}</h3>
              </div>
              <p className="text-sm text-[#5A6B63] leading-relaxed">{c.desc}</p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-[#0E6E52] group-hover:gap-2 transition-all duration-200">
                Open <ArrowRight className="w-4 h-4" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}
